export default __webpack_public_path__ + "static/media/camera-upload.63bb4632.svg";